import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Navigation } from "@/components/Navigation";
import { LogoBanner } from "@/components/LogoBanner";
import { Hero } from "@/components/Hero";
import { Protocols } from "@/components/Protocols";
import { Bio } from "@/components/Bio";
import { Testimonials } from "@/components/Testimonials";
import { Resources } from "@/components/Resources";
import { Insights } from "@/components/Insights";
import { Footer } from "@/components/Footer";
import { Privacy, Terms } from "@/pages/Legal";
import { Protocol } from "@/pages/Protocol";
import { Quiz } from "@/pages/Quiz";
import { Admin } from "@/pages/Admin";
import { NotFound } from "@/pages/NotFound";
import { ThankYou } from "@/pages/ThankYou";
import { Article } from "@/pages/Article";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { FloatingQuiz } from "@/components/FloatingQuiz";
import { CookieBanner } from "@/components/CookieBanner";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

const Home = () => (
    <>
        <Navigation />
        <main>
            <LogoBanner />
            <Hero />
            <Bio />
            <Protocols />
            <Insights />
            <Resources id="risorse" />
            <Testimonials />
        </main>
        <Footer />
    </>
);

function App() {
    return (
        <LanguageProvider>
            <AuthProvider>
                <div className="App bg-black text-white antialiased">
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/termini" element={<Terms />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/protocollo/:slug" element={<Protocol />} />
                            <Route path="/protocol/:slug" element={<Protocol />} />
                            <Route path="/insights/:slug" element={<Article />} />
                            <Route path="/quiz" element={<Quiz />} />
                            <Route path="/grazie" element={<ThankYou />} />
                            <Route path="/thank-you" element={<ThankYou />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                        <FloatingWhatsApp />
                        <FloatingQuiz />
                        <CookieBanner />
                    </BrowserRouter>
                </div>
            </AuthProvider>
        </LanguageProvider>
    );
}

export default App;
